"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform["CC"] = "CC";
    Platform["OFI"] = "OFI";
    Platform["DRP"] = "DRP";
})(Platform || (exports.Platform = Platform = {}));
//# sourceMappingURL=usdInformationModelbank.js.map